import React from "react";
import { Music2, Play, Headphones, Plus } from "lucide-react";

const playlists = [
  {
    name: "Heavy Days",
    by: "Marcus",
    tracks: 22,
    minutes: 78,
    platform: "Spotify",
    color: "#1ED760",
    cover:
      "https://images.unsplash.com/photo-1518609878373-06d740f60d8b?auto=format&fit=crop&w=600&q=80",
  },
  {
    name: "Long Run Sundays",
    by: "Nia",
    tracks: 34,
    minutes: 124,
    platform: "Apple Music",
    color: "#FA243C",
    cover:
      "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?auto=format&fit=crop&w=600&q=80",
  },
];

const Playlist = () => {
  return (
    <section
      id="playlist"
      data-testid="playlist-section"
      className="relative py-24 md:py-32 bg-[#0A0A0A] overflow-hidden"
    >
      <div className="absolute right-0 top-1/4 w-[420px] h-[420px] rounded-full bg-[#C6FF00]/10 blur-[140px] pointer-events-none" />

      <div className="relative container mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Left text */}
          <div className="lg:col-span-5">
            <p className="text-xs uppercase tracking-[0.3em] text-[#C6FF00] font-semibold mb-4">
              Vibe Layer
            </p>
            <h2 className="font-heading text-5xl md:text-6xl lg:text-7xl text-white leading-[0.95]">
              Share Your
              <br />
              <span className="text-[#C6FF00]">Sound.</span>
            </h2>
            <p className="mt-6 text-base md:text-lg text-neutral-300 max-w-md leading-relaxed">
              Music sets the tone. Let them know your vibe before you meet.
            </p>
            <p className="mt-4 text-sm text-neutral-400 max-w-md leading-relaxed">
              Link your Spotify or Apple Music gym playlist on your profile and during
              matches. Trade hype tapes. Press play together when the workout starts.
            </p>

            <button
              type="button"
              data-testid="playlist-add-btn"
              className="mt-10 inline-flex items-center gap-2 bg-transparent border-2 border-[#C6FF00] hover:bg-[#C6FF00]/10 text-[#C6FF00] font-bold text-sm uppercase tracking-[0.25em] px-7 py-4 rounded-md transition-all hover:scale-[1.02]"
            >
              <Plus size={16} /> Add Your Playlist
            </button>
          </div>

          {/* Right playlist cards */}
          <div className="lg:col-span-7 space-y-4">
            {playlists.map((p, i) => (
              <div
                key={p.name}
                data-testid={`playlist-card-${i}`}
                className="group flex items-center gap-5 bg-[#111] border border-white/5 hover:border-[#C6FF00]/40 rounded-2xl p-4 sm:p-5 transition-all duration-300"
              >
                <div className="relative w-20 h-20 sm:w-24 sm:h-24 rounded-xl overflow-hidden flex-shrink-0">
                  <img src={p.cover} alt={p.name} className="w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-tr from-black/70 via-transparent to-transparent" />
                  <div className="absolute bottom-2 left-2">
                    <Music2 size={14} className="text-white drop-shadow" />
                  </div>
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span
                      className="w-2 h-2 rounded-full flex-shrink-0"
                      style={{ background: p.color }}
                    />
                    <span className="text-[10px] uppercase tracking-[0.25em] text-neutral-500 font-semibold">
                      {p.platform}
                    </span>
                  </div>
                  <h3 className="font-heading text-2xl md:text-3xl text-white tracking-wide leading-none truncate">
                    {p.name}
                  </h3>
                  <div className="flex items-center gap-3 text-[11px] text-neutral-400 mt-2">
                    <span>by {p.by}</span>
                    <span className="text-neutral-600">·</span>
                    <span>{p.tracks} tracks</span>
                    <span className="text-neutral-600">·</span>
                    <span>{p.minutes}m</span>
                  </div>
                </div>

                <button
                  type="button"
                  className="w-12 h-12 rounded-full bg-[#C6FF00] text-[#0A0A0A] flex items-center justify-center transition-all hover:scale-110 shadow-[0_0_20px_rgba(198,255,0,0.35)] flex-shrink-0"
                  aria-label="Play during session"
                  data-testid={`playlist-play-${i}`}
                >
                  <Play size={16} fill="currentColor" />
                </button>
              </div>
            ))}

            <div className="flex items-center gap-3 px-5 py-4 rounded-2xl border border-dashed border-white/10 text-xs uppercase tracking-[0.2em] text-neutral-500 font-semibold">
              <Headphones size={14} className="text-[#C6FF00]" />
              Press play together when the session starts.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Playlist;
